/**
 * SOTA viewport ladder — single source for ops + field responsive layout.
 *
 * Design QA targets (width × typical height):
 *   phone   360×800   → xs
 *   large phone / phablet 600×… → sm
 *   tablet  900×…     → md
 *   laptop  1200×…    → lg
 *   desktop 1536×…    → xl
 *
 * Aligns with MUI default breakpoint values and `.agents/design/SOTA_STANDARDS.md`.
 */
export const SOTA_VIEWPORTS = {
  phone: 360,
  largePhone: 600,
  tablet: 900,
  laptop: 1200,
  desktop: 1536,
} as const;

/** MUI `createTheme().breakpoints.values` — must stay in sync with SOTA_VIEWPORTS. */
export const PAYGO_BREAKPOINTS = {
  xs: 0,
  sm: SOTA_VIEWPORTS.largePhone,
  md: SOTA_VIEWPORTS.tablet,
  lg: SOTA_VIEWPORTS.laptop,
  xl: SOTA_VIEWPORTS.desktop,
} as const;

export type PaygoBreakpoint = keyof typeof PAYGO_BREAKPOINTS;

/** Content max-widths per band (readable measure, not full bleed). */
export const PAGE_MAX_WIDTH = {
  xs: "100%",
  sm: "100%",
  md: 900,
  lg: 1200,
  xl: 1440,
} as const;
